import { Shield, Server, Lock, Building } from "lucide-react";
import { useLanguage } from "@/hooks/useLanguage";
import { Badge } from "@/components/ui/badge";

const icons = [Server, Shield, Lock, Building];

const SecuritySection = () => {
  const { t, tObject } = useLanguage();
  const features = tObject<Array<{ label: string }>>('security.features');
  
  return (
    <section id="sicherheit" className="py-16 md:py-24 bg-secondary/30">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <Badge variant="outline" className="mb-4 text-sm font-semibold text-primary uppercase tracking-wider">{t('security.tag')}</Badge>
          <h2 className="text-3xl md:text-4xl font-semibold text-foreground mb-4">
            {t('security.title')}
          </h2>
          <p className="text-lg text-chathero-orange font-semibold mb-12">
            {t('security.subtitle')}
          </p>

          <div className="grid sm:grid-cols-2 gap-6">
            {features.map((feature, index) => {
              const Icon = icons[index % icons.length];
              return (
                <div
                  key={index}
                  className="flex items-center gap-4 bg-background rounded-xl p-6 border border-border hover:border-chathero-mint hover:shadow-[0_4px_24px_rgba(0,196,180,0.08)] transition-all duration-300 group"
                >
                  <div className="w-12 h-12 rounded-xl bg-chathero-mint/10 border border-chathero-mint/30 flex items-center justify-center flex-shrink-0 group-hover:bg-chathero-mint/20 transition-colors">
                    <Icon className="w-6 h-6 text-primary" />
                  </div>
                  <span className="text-lg font-medium text-foreground">{feature.label}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SecuritySection;